import React from 'react'
import { Highlight } from 'react-instantsearch/dom';
import { connect } from 'kea'

import logic from '~/components/search/logic'

@connect({
  actions: [
    logic, [
      'navigateTo',
    ]
  ],
})
class Product extends React.Component {

  handleClick = (e) => {
    e.preventDefault();

    const { hit } = this.props;
    const { navigateTo } = this.props.actions;

    const link = `/products/${hit.objectID}/edit/`;

    navigateTo(link);
  };

  render() {
    const { hit } = this.props;

    return (
      <div className="result product-result" onClick={ this.handleClick }>
        <span className="primary hit-name">
          <Highlight attribute="name" hit={hit} />
        </span>
          { hit.tickets__name ?
            <span className="secondary hit-tickets__name">
            { ' - ' }
              <Highlight attribute="tickets__name" hit={hit} />
          </span>
            : null }
          { hit.tickets__venue ?
            <span className="secondary hit-tickets__venue">
            { ' - ' }
              <Highlight attribute="tickets__venue" hit={hit} />
          </span>
            : null }
          { hit.downloads__name ?
            <span className="secondary hit-downloads__name">
            { ' - ' }
              <Highlight attribute="downloads__name" hit={hit} />
          </span>
            : null }
      </div>
    )
  }
}
export default Product